import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box, IconButton, Tab } from "@mui/material";
import { message, Popconfirm } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axios/axios-instance";
import Card from "../../components/common/Card";
import MuiTable from "../../components/common/MuiTable";
import { Column, HELP_SUPPORT_STATUS, OptionFilter, SearchForm } from "../../utils/constants";
import { pathAPI } from "../../utils/pathApi";
import "./HelpSupport.scss";


const HelpSupport = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [value, setValue] = useState("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === '1') {
      setRequest((previousRequest) => ({...previousRequest, isUser: true}));
    } else {
      setRequest((previousRequest) => ({...previousRequest, isUser: false}));
    }
  };

  const [request, setRequest] = useState<SearchForm>({
    isUser: true,
    page: 0,
    size: 20,
    search: '',
    filter: ''
  })

  const filterConsts: OptionFilter[] = [
    {value: "", label: "All"},
    {value: "waiting", label: `${t("common.filter_navbar.waiting")}`},
    {value: "supporting", label: `${t("common.filter_navbar.supporting")}`},
    {value: "closed", label: `${t("common.filter_navbar.closed")}`},
  ];

  const [dataSource, setDataSource] = useState<any>([]);

  const deleteSuccess = () => {
    messageApi.open({
      type: "success",
      content: "Delete item successfully!",
    });
  };

  const getListSupportTicket = async () => {
    setIsLoadingData(true);
    await axiosInstance.get(pathAPI.supportTicket, {params: request})
    .then((data: any) => {
      setIsLoadingData(false);
      const endData = data.data.content.map((item: any) => ({
          ...item,
          action: item.id,
        }));
      setDataSource(endData)
    })
    .catch((e: any) => {console.log("======== ERROR: ", e); setIsLoadingData(false)})
  }

  const handleDelete = async (id: number) => {
    await axiosInstance.delete(`${pathAPI.supportTicket}/${id}`);
    deleteSuccess();
    getListSupportTicket();
  }
  
  useEffect(() => {
    getListSupportTicket();
  }, [request])

  const header: Column[] = [
    {
      id: "id",
      label: `${t("common.table.id")}`,
      minWidth: 10,
      align: "center",
    },
    {
      id: "title",
      label: `${t("common.table.title")}`,
      minWidth: 250,
      align: "center",
    },
    {
      id: "description",
      label: `${t("common.table.description")}`,
      minWidth: 80,
      align: "center",
    },
    {
      id: "status",
      label: `${t("common.table.status")}`,
      minWidth: 10,
      width: 30,
      align: "center",
      format: (value: any) => {
        return <div className={`font-bold px-2 rounded-lg ${statusTransform(value)?.style}`}>{`${statusTransform(value)?.value}`}</div>;
      },
    },
    {
      id: "created_date",
      label: `${t("common.table.created_date")}`,
      minWidth: 80,
      align: "center",
      format: (value: any) => {
        return <div>{moment(value).format("YYYY/MM/DD HH:mm:ss")}</div>;
      }
    },
    {
      id: "action",
      label: t("common.table.actions"),
      minWidth: 100,
      align: "center",
      format: (id: number) => {
        return (
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={2}
          >
            <Box
              size={"small"}
              component={IconButton}
              disabled={loadingDelete}
              onClick={() => navigate(`${id}`)}
            >
              <EditIcon color="success" />
            </Box>
            <Popconfirm
              title={t("help_support.delete_text")}
              okText={t("btn.confirm")}
              cancelText={t("btn.cancel")}
              onConfirm={() => handleDelete(id)}
              okButtonProps={{
                style: { background: "#ba2156", border: "none" },
                loading: loadingDelete,
              }}
            >
              <Box size={"small"} component={IconButton}>
                <DeleteIcon color={"error"} />
              </Box>
            </Popconfirm>
          </Box>
        );
      },
    },
  ];

  const statusTransform = (status: string) => {
      switch (status) {
        case HELP_SUPPORT_STATUS.WAITING:
          return {style: 'bg-red-500', value: 'Waiting'}
        case HELP_SUPPORT_STATUS.CLOSED:
          return {style: 'bg-gray-400', value: 'Closed'}
        case HELP_SUPPORT_STATUS.SUPPORTING:
          return {style: 'bg-green-400', value: 'Supporting'}
      
        default:
          break;
      }
    }

  return (
    <Card>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            TabIndicatorProps={{ sx: { backgroundColor: "#ba2156" } }}
            sx={{ "& .MuiTab-root.Mui-selected": { color: "#ba2156" } }}
          >
            <Tab label="USER" value="1" />
            <Tab label="SALONS" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <MuiTable header={header} data={dataSource} isLoading={isLoadingData}></MuiTable>
        </TabPanel>
        <TabPanel value="2">
          <MuiTable header={header} data={dataSource} isLoading={isLoadingData}></MuiTable>
        </TabPanel>
      </TabContext>
    </Card>
  );
};
export default HelpSupport;
